import { createAsyncThunk } from '@reduxjs/toolkit';

import { DashboardService } from '../../services';

export const fetchDashboardCounters = createAsyncThunk(
  'dashboard/fetchCounters',
  async (params, { rejectWithValue }) => {
    try {
      const response = await DashboardService.fetchCounters(params);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch dashboard counters');
    }
  }
);
